import { useEffect } from "react";
import { useRouter } from "next/router";
import { trackUserInteraction } from "@/api/requests/user-interaction/requests";
import { InteractionTypeDto } from "@/api/generated/models";

const trackPageVisit = async (pageUrl: string): Promise<void> =>
  trackUserInteraction({
    type: InteractionTypeDto.ViewPage,
    pageUrl: pageUrl,
  });

const useViewPageTracking = (): void => {
  const router = useRouter();

  useEffect(() => {
    trackPageVisit(router.pathname);
  }, []);
};

export default useViewPageTracking;
